import React from 'react'
import BlogCard from './BlogCard.component'

import Blog1 from "../../assets//images/blog/img-01.jpg";

export default function BlogsList(props) {

	const blogData = [
		{
		  imgUrl: Blog1,
		  title: "The quickest way to deliver your message? make it visual",
		  detail:
			"The quickest way to deliver your message? make it visual Ante excepturi sint occaecati cupiditate noinerate que sunten culpa qui officiale deserunt.",
		  categories: ["Marketing", "Busines development"],
		},
		{
		  imgUrl: Blog1,
		  title: "Why you should forget facebook and start using wibleo",
		  detail:
			"Ante excepturi sint occaecati cupiditate noinerate que sunten culpa qui officiale deserunt.",
		  categories: ["Technology", "IT"],
		},
		{
		  imgUrl: Blog1,
		  title: "Why steve markinson didn’t let his kids use iPads",
		  detail:
			"Ante excepturi sint occaecati cupiditate noinerate que sunten culpa qui officiale deserunt.",
		  categories: ["Mobile", "Entertainment"],
		},
	  ];

	return (
    <>
        {/* <!-- Friends Start --> */}
		<section className="bds-main-section">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="bds-maintitle">
							<h2>Blogs</h2>
						</div>
					</div>
				</div>
				<div className="row bds-blogs-main">
					{
						blogData?.map((blog, idx) => 
							<BlogCard 
								key={idx}
								imgUrl={blog.imgUrl}
								title={blog.title}
								detail={blog.detail}
								categories={blog.categories}
							/>						
						)
					}
				</div>
			</div>
		</section>
		{/* <!-- Friends End --> */}
    </>
  )
}
